import { reduxKey } from './constants';
export var WriterError;
(function (WriterError) {
    WriterError["GifCountExceeded"] = "gif count exceeded";
    WriterError["EmoteCountExceeded"] = "emote count exceeded";
    WriterError["ImageCountExceeded"] = "image count exceeded";
    WriterError["MentionCountExceeded"] = "mention count exceeded";
    WriterError["ContentTooLong"] = "content too long";
    WriterError["Unspecified"] = "error unspecified";
})(WriterError || (WriterError = {}));
export var WriterPopupType;
(function (WriterPopupType) {
    WriterPopupType["JOURNAL"] = "JOURNAL";
    WriterPopupType["LITERATURE"] = "LITERATURE";
})(WriterPopupType || (WriterPopupType = {}));
//# sourceMappingURL=types.js.map